if (is_defined === undefined) {
  var is_defined = function(suspect) {
    return (suspect === undefined) ? false : true;
  };
}

if (!is_defined(is_undefined)) {
  var is_undefined = function(suspect) {
    return (suspect === undefined) ? true : false;
  };
}

// Null console to prevent errors in IE caused by console.log
if (is_undefined(window.console)) {
  window.console = { log: jQuery.noop, dir: jQuery.noop, error: jQuery.noop };
}

// Defining global 'contently' namespace
if (is_undefined(contently)) {
  var contently = {
    ui: {}
  };
}


// Initialize 'contently' namespace
(function($, contently) {

  contently.is_noop_action = function(action) {
    if (!action) return true;
    if (action.length == 0) return true;
    if (action[0] == "#") return true;
    if (action.indexOf("javascript") == 0) return true;

    return false;
  };

  contently.is_not_noop_action = function(action) {
    return !self.is_noop_action(action);
  };

})(jQuery, contently);



// WEBPACK FOOTER //
// ./app/javascript/lib/contently.js